export enum BaseUrl {
	NOTIFICATION = "notification",
	DEFAULT = "default",
	HUB = "hub",
	BANKING = "banking",
	SELLER = "seller",
}
